import qs from "qs";
import {
  defaultOpportunitySearchQuery,
  OpportunitySearchQueryState,
} from "../context/OpportunitySearchQuery";

import { pick } from "lodash-es";

function alphabeticalSort(a: string, b: string): number {
  return a.localeCompare(b);
}

const qsOptions: qs.IStringifyOptions = {
  arrayFormat: "repeat",
  // sorts keys, not values
  sort: alphabeticalSort,
};

const KEYS: (keyof OpportunitySearchQueryState)[] = [
  "category",
  "commitment",
  "daytime",
  "keyword",
  "organisationId",
  "page",
  "radius",
  "suitablefor",
  "typeofwork",
  "where",
];

export const normalizeQuery = (
  searchQuery?: OpportunitySearchQueryState
): OpportunitySearchQueryState => {
  if (searchQuery === undefined) {
    return defaultOpportunitySearchQuery;
  }

  // remove all unused keys
  searchQuery = pick(searchQuery, KEYS);

  // normalize query with default from server
  // empty keyword on server is null
  if (searchQuery.keyword === "") {
    searchQuery.keyword = null;
  }

  // query.where make each word uppercase
  // and remove extraenous spaces
  if (searchQuery.where === "") {
    searchQuery.where = null;
  }

  // server page property default is null
  if (searchQuery.page === 1) {
    searchQuery.page = null;
  }

  // remove duplicate entries and
  // sort arrays from lowest to highest
  for (const key in searchQuery) {
    if (Array.isArray(searchQuery[key])) {
      searchQuery[key] = [...Array.from(new Set<number>(searchQuery[key]))];
      searchQuery[key] = searchQuery[key].sort((a, b) => a - b);
    }
  }

  return searchQuery;
};

export const opportunitySearchQueryToString = (
  searchQuery?: OpportunitySearchQueryState
): string => {
  if (searchQuery === undefined) {
    return qs
      .stringify(defaultOpportunitySearchQuery, qsOptions)
      .toLocaleLowerCase();
  }

  return qs
    .stringify(
      { ...defaultOpportunitySearchQuery, ...normalizeQuery(searchQuery) },
      qsOptions
    )
    .toLocaleLowerCase();
};
